import { render, staticRenderFns } from "./courseInfoSetting.vue?vue&type=template&id=8bd93a3c&scoped=true&"
import script from "./courseInfoSetting.vue?vue&type=script&lang=js&"
export * from "./courseInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./courseInfoSetting.vue?vue&type=style&index=0&id=8bd93a3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd93a3c",
  null
  
)

export default component.exports